export default "__VITE_ASSET__BuGGgTtf__"